define([
    "jquery",
    "underscore",
    "marionette",
    "clipboard-js"
], function($, _, Marionette, clipboard) {

    let beforePartnerClickedText;
    let afterPartnerClickedText;

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {

        },

        ui: {
            'tooltipModal': '#tooltip-contents',
            'tooltipModalSpread': '#spread',
            'tooltipModalReward': '#reward',
            'tooltipBtn': '.mobile-popup',
            'tooltipClose': '#tooltip-contents .close',
            'spreadTooltipClose': '#spread .close',
            'rewardTooltipClose': '#reward .close',
            'spreadBtn': '.spread-btn',
            'rewardBtn': '.reward-btn',
            'spread': '.spread',
            'reward': '.reward',
            'partnerLink': '#partner-link',
            'partnerLinkBtn': '#partner-link-copy',
        },

        events: {
            'click @ui.tooltipBtn': 'onShowMobileTooltip',
            'click @ui.tooltipClose': 'onHideMobileTooltip',
            'click @ui.partnerLinkBtn': 'copyPartnerLink',
        },

        initialize: function() {
            this.bindUIElements();
            this.addEventListeners();
            this.beforePartnerClickedText = this.ui.partnerLinkBtn.text();
            this.afterPartnerClickedText = window.afterPartnerClickedText;
        },

        addEventListeners: function() {
            const that = this;
            $(document).ready(function() {
                that.toggleTooltipButtonListeners();
                $(window).on('resize', function() {
                    that.toggleTooltipButtonListeners();
                });
            })
        },

        onShowMobileTooltip: function() {
            this.ui.tooltipModal['0'].style.display = "block";
        },

        onHideMobileTooltip: function() {
            this.ui.tooltipModal['0'].style.display = "none";
        },

        toggleTooltipButtonListeners: function() {
            const that = this;
            if(document.body.clientWidth < 992) {
                // spread tooltip
                that.ui.spreadBtn.off('mouseenter');
                that.ui.spreadBtn.off('mouseleave');
                that.ui.spreadBtn.on('click', function() {
                    that.ui.tooltipModalSpread['0'].style.display = 'block';
                });
                that.ui.spreadTooltipClose.on('click', function() {
                    that.ui.tooltipModalSpread['0'].style.display = 'none';
                })

                // reward tooltip
                that.ui.rewardBtn.off('mouseenter');
                that.ui.rewardBtn.off('mouseleave');
                that.ui.rewardBtn.on('click', function() {
                    that.ui.tooltipModalReward['0'].style.display = 'block';
                });
                that.ui.rewardTooltipClose.on('click', function() {
                    that.ui.tooltipModalReward['0'].style.display = 'none';
                })
            } else {
                // spread tooltip
                that.ui.spreadBtn.off('click');
                that.ui.tooltipModalSpread.off('click');
                that.ui.spreadBtn.on('mouseenter', function() {
                    that.ui.spread['0'].style.display = 'block';
                });
                that.ui.spreadBtn.on('mouseleave', function() {
                    that.ui.spread['0'].style.display = 'none';
                });

                // reward tooltip
                that.ui.rewardBtn.off('click');
                that.ui.tooltipModalReward.off('click');
                that.ui.rewardBtn.on('mouseenter', function() {
                    that.ui.reward['0'].style.display = 'block';
                });
                that.ui.rewardBtn.on('mouseleave', function() {
                    that.ui.reward['0'].style.display = 'none';
                });
            }
        },

        copyPartnerLink: function() {
            const that = this;
            that.ui.partnerLinkBtn.css('background-color', '#1f3fcd');
            that.ui.partnerLinkBtn.text(that.afterPartnerClickedText);
            clipboard.copy(this.ui.partnerLink.val());
            setTimeout(() =>{
                that.ui.partnerLinkBtn.css('background-color', '#464d5b');
                that.ui.partnerLinkBtn.text(that.beforePartnerClickedText);
            }, 3000)
        },

        onClose: function() {
            $(window).off("resize");
        }
    })
})